import React, { useState } from "react";
import * as Yup from "yup";
import RippleLoader from "../../../components/loader/RippleLoader";
import { Form, Formik } from "formik";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import { createOutlet, getByIdOutlet } from "../../../redux/companies/slice";
import { useDispatch } from "react-redux";
import { InputWithLabel } from "../../../components/micro/input";

const EditGeneralDetails = ({ onClose, outletData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const isEditMode = outletData?.length > 0;

  const handleFormSubmit = async (values) => {
    const payload = {
      id: outletData.id,
      company_id: outletData?.company_id,
      name: values.outletName,
      address: values.address,
      postal_code: values.postalCode,
      is_client: 1,
    };
    setIsLoading(true);
    dispatch(createOutlet(payload))
      .then((res) => {
        if (res.type === "createOutlet/fulfilled") {
          onClose();
          dispatch(getByIdOutlet(outletData?.id));
        }
        setShowConfirmationModal(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const initialValues = {
    outletName: outletData?.name || "",
    address: outletData?.address || "",
    postalCode: outletData?.postal_code || "",
  };

  return (
    <>
      <div className="model" onClick={onClose} style={{ zIndex: 1300 }}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-[34px] font-normal">
            Edit Outlet Detail
          </h4>
          {isLoading ? (
            <RippleLoader />
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object().shape({
                outletName: Yup.string()
                  .trim()
                  .required("Please enter outlet name"),
                address: Yup.string().trim().required("Please enter address"),
                postalCode: Yup.string()
                  .trim()
                  .required("Please enter postal code")
                  .length(6, "Postal code must be exactly 6 digits")
                  .matches(/^\d+$/, "Postal code must be numeric"),
              })}
              onSubmit={(values) => {
                setFormValues(values);
              }}
            >
              {({
                values,
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                validateForm,
                setFieldTouched,
                handleBlur,
                handleChange,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <>
                    <div className="flex justify-between items-center gap-8 mt-3">
                      <div className="flex-grow mb-4 grid gap-4">
                        <InputWithLabel
                          className={`${"text-black  border hover:border-themeBtn"}  ${
                            errors.outletName && touched.outletName
                              ? `border border-red`
                              : `border border-borderTheme/80 focus-within:border-themeBtn `
                          }  transition duration-300 ease-in-out`}
                          idFromName="outletName"
                          label="Outlet Name*"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.outletName}
                          errors={errors.outletName && touched.outletName}
                          errorsText={errors.outletName}
                        />
                        <InputWithLabel
                          className={`${"text-black  border hover:border-themeBtn"}  ${
                            errors.address && touched.address
                              ? `border border-red`
                              : `border border-borderTheme/80 focus-within:border-themeBtn `
                          }  transition duration-300 ease-in-out`}
                          idFromName="address"
                          label="Address*"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          errors={errors.address && touched.address}
                          errorsText={errors.address}
                        />
                        <InputWithLabel
                          className={`${"text-black  border hover:border-themeBtn"}  ${
                            errors.postalCode && touched.postalCode
                              ? `border border-red`
                              : `border border-borderTheme/80 focus-within:border-themeBtn `
                          }  transition duration-300 ease-in-out`}
                          idFromName="postalCode"
                          label="Postal Code*"
                          type="number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.postalCode}
                          errors={errors.postalCode && touched.postalCode}
                          errorsText={errors.postalCode}
                          onFocus={(e) =>
                            e.target.addEventListener(
                              "wheel",
                              function (e) {
                                e.preventDefault();
                              },
                              { passive: false }
                            )
                          }
                        />
                      </div>
                    </div>
                  </>
                  {/* Submit button */}
                  <div className="flex justify-end gap-3 mt-3 w-full">
                    <button
                      onClick={onClose}
                      type="button"
                      className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="button"
                      onClick={async () => {
                        const errors = await validateForm();
                        const isValid = Object.keys(errors).length === 0;

                        if (isValid) {
                          setFormValues(values);
                          setShowConfirmationModal(true);
                        }
                      }}
                      className={`${
                        values?.salesPerson?.length === 0
                          ? "cursor-not-allowed bg-borderLine text-textSecondary"
                          : "bg-themeBtn text-white"
                      } flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase`}
                    >
                      <span>Confirm</span>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>

        {/* Confirmation modals */}
        {showConfirmationModal && (
          <ConfirmationModel
            confirmText={isEditMode ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleFormSubmit(formValues)}
            isLoading={isLoading}
          />
        )}
      </div>
    </>
  );
};

export default EditGeneralDetails;
